/**
 * One entry per metro the beta opens. A city page is copy plus this record; adding a city is a
 * record here, a route in App.tsx, a shell in scripts/spa-shell-routes.mjs, meta in
 * scripts/copy-spa-shells.mjs, and the apex path in the load balancer (see README).
 */
export type CityVenue = {
  name: string;
  /** Neighbourhood or a street, the way a local would say it. */
  area: string;
  href?: string;
};

export type CityPageConfig = {
  slug: string;
  name: string;
  state: string;
  venues: readonly CityVenue[];
};

export const CITIES: Record<'austin', CityPageConfig> = {
  austin: {
    slug: 'austin',
    name: 'Austin',
    state: 'Texas',
    venues: [],
  },
};
